import React from 'react';
import BulkQuickFixPage from './BulkQuickFixPage';
import { fetchInvalidPartAttributeValues } from '../../../actions/items/ai_quick_fixes/bulk';
import { INVALID_PART_ATTRIBUTE_VALUES_ANALYSIS_ID } from '../../../constants/InboxConstants';
import { ApplicationState } from '../../../reducers';

const PartAttributeValuesQuickFixPage: React.FC = () => {
  return (
    <BulkQuickFixPage
      config={{
        analysisId: INVALID_PART_ATTRIBUTE_VALUES_ANALYSIS_ID,
        fetchAction: fetchInvalidPartAttributeValues,
        loadingSelector: (state: ApplicationState) =>
          state.items.bulkAIQuickFixes.fetchInvalidPartAttributeValues,
        dataSelector: (state: ApplicationState) =>
          state.items.bulkAIQuickFixes.invalidPartAttributeValuesData,
        emptyStateDescription: 'quickfix:noInvalidPartAttributeValues',
        displayMode: 'nested',
      }}
    />
  );
};

export default PartAttributeValuesQuickFixPage;
